// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from "./application"
import { registerControllers } from 'stimulus-vite-helpers'

import { Dropdown, Modal, Tabs, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components"
import Flatpickr from 'stimulus-flatpickr'

// Register each controller with Stimulus
const controllers = import.meta.globEager('./*_controller.js')
registerControllers(application, controllers)

application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('popover', Popover)
application.register('toggle', Toggle)
application.register('slideover', Slideover)
application.register('flatpickr', Flatpickr)
